const e = {
  type: "text",
  size: "medium"
}, o = {
  rows: 2,
  lineHeight: 22
}, s = [
  "className",
  "style",
  "id",
  "label",
  "placeholder",
  "showRequired",
  "disabled",
  "placeholderColor",
  "value",
  "type",
  "trim",
  "inputClassName",
  "inputStyle",
  "prefixClassName",
  "suffixClassName",
  "size",
  "icon",
  "iconWidth",
  "prefix",
  "suffix",
  "color",
  "activeBorderColor",
  "borderColor",
  "status",
  "onChange",
  "iconOnClick",
  "onBlur",
  "onEnter",
  "allowClear",
  "infoMessage",
  "loading",
  "onSearch",
  "containerClassName",
  "containerStyle",
  "backgroundColor",
  "shouldEscape",
  "suffixOnClick"
], a = [
  "rows",
  "lineHeight",
  "overMaxLength",
  "maxLength",
  "value",
  "textAreaClassName",
  "status",
  "showCount",
  "showRequired",
  "className",
  "placeholderColor",
  "color",
  "borderColor",
  "activeBorderColor",
  "textAreaStyle",
  "style",
  "onChange",
  "onFocus",
  "onBlur",
  "infoMessage",
  "shouldEscape"
];
export {
  e as defaultInputProps,
  o as defaultTextAreaProps,
  s as omitProps,
  a as omitTextAreaPropsKeys
};
//# sourceMappingURL=const.mjs.map
